export class DateFormatter {
  private locale: string;

  constructor(locale: string = 'en-US') {
    this.locale = locale;
  }

  formatLong(date: string | null): string {
    return this.format(date, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  }

  formatShort(date: string | null): string {
    return this.format(date, {
      month: 'short',
      day: 'numeric',
      year: '2-digit',
    });
  }

  formatISO(date: string | null): string {
    if (!date) return '';
    const parsedDate = new Date(date);
    return isNaN(parsedDate.getTime()) ? '' : parsedDate.toISOString();
  }

  private format(date: string | null, options: Intl.DateTimeFormatOptions): string {
    if (!date) return '';
    const parsedDate = new Date(date);
    if (isNaN(parsedDate.getTime())) return '';
    return new Intl.DateTimeFormat(this.locale, options).format(parsedDate);
  }
}
